export class UserEnvironment {
  public static getName = () => 'benzinga-user-settings';
  public static getEnvironment = (env: Record<string, string>) => ({
    url: new URL(env.url ?? 'https://accounts.benzinga.com/'),
  });
}
